import { Progress, Tooltip, utils as u } from 'edrolo-ui';
import { useContext } from 'react';
import { ClassContext } from 'edrolo/context';
import { useClassProgress } from 'edrolo/domains/bySchoolClass';
import { Exam } from '../../../../../../../types/Assemblage';

interface Props {
  questionSet: Exam;
}

export const ResponsesProgress = ({
  questionSet,
}: Props): JSX.Element | null => {
  const {
    data: { classId },
  } = useContext(ClassContext);

  const { data, loading, error } = useClassProgress(classId);

  if (loading || error) {
    return null;
  }

  const avgCount = Math.round(
    data.exams[questionSet.id]?.completed_responses_avg || 0
  );
  const totalCount = questionSet.question_count;

  return (
    <Tooltip
      tip={`Students have completed an average of ${avgCount} out of ${totalCount} questions`}
    >
      <Progress.Circle
        numerator={avgCount}
        denominator={totalCount}
        className={u.mr2}
      />
    </Tooltip>
  );
};
